import React, { useMemo } from "react";
import styles from "./Pagination.module.css";
import { DataPerPage } from "../ArticleContent/ArticleContent";
import { ReactComponent as LeftArrow } from "assets/icons/left-arrow-icon.svg";
import { ReactComponent as RightArrow } from "assets/icons/right-arrow-icon.svg";

interface Props {
  page: number;
  totalCount: number;
  onChange: (pageNumber: number) => void;
}

const Pagination = ({ page, totalCount, onChange }: Props) => {
  const totalPages = Math.ceil(totalCount / DataPerPage);
  const hasNext = page < totalPages;
  const hasPrev = page > 1;

  const nextPage = () => {
    hasNext && onChange(page + 1);
  };

  const prevPage = () => {
    hasPrev && onChange(page - 1);
  };

  const pageLabels: (number | string)[] = useMemo(() => {
    if (totalPages <= 5) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    if (page === 1) {
      return [page, page + 1, page + 2, "...", totalPages];
    }

    if (page === 2) {
      return [1, page, page + 1, "...", totalPages];
    }

    if (page === totalPages - 1) {
      return [1, "...", page - 1, page, totalPages];
    }

    return [1, "...", page, "...", totalPages];
  }, [page, totalPages]);

  return (
    <div className={styles.pagination_container}>
      <div onClick={prevPage} className={styles.arrow_container}>
        <LeftArrow
          fill="#121212"
          className={hasPrev ? styles.arrow : styles.arrow_disabled}
        />
      </div>
      {pageLabels.map((num, index) => {
        if (num !== "...") {
          return (
            <div
              onClick={() => onChange(num as number)}
              className={
                num === page ? styles.pageBlockActive : styles.pageBlockInactive
              }
              key={index}
            >
              {num}
            </div>
          );
        } else {
          return (
            <div className={styles.pageBlockInactive} key={index}>{`...`}</div>
          );
        }
      })}
      <div onClick={nextPage} className={styles.arrow_container}>
        <RightArrow
          fill="#121212"
          className={hasNext ? styles.arrow : styles.arrow_disabled}
        />
      </div>
    </div>
  );
};

export default Pagination;
